import { render, staticRenderFns } from "./map.vue?vue&type=template&id=57271ef1&scoped=true"
import script from "./map.vue?vue&type=script&lang=js"
export * from "./map.vue?vue&type=script&lang=js"
import style0 from "./map.vue?vue&type=style&index=0&id=57271ef1&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57271ef1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57271ef1')) {
      api.createRecord('57271ef1', component.options)
    } else {
      api.reload('57271ef1', component.options)
    }
    module.hot.accept("./map.vue?vue&type=template&id=57271ef1&scoped=true", function () {
      api.rerender('57271ef1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/tencent_map/map.vue"
export default component.exports